import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue';

type Option = {
  label: string;
  value: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'SingleSelect',
  props: {
  label: {
    type: String,
    required: false,
    default: '',
  },
  name: {
    type: String,
    required: true,
  },
  value: {
    type: String,
    required: false,
    default: '',
  },
  options: {
    type: Array as PropType<Option[]>,
    required: true,
    default: () => [],
  },
},
  emits: ["change"],
  setup(__props, { emit: emits }: { emit: ({
  (e: 'change', value: string): void;
}), expose: any, slots: any, attrs: any }) {





const onChange = (payload: Event) => {
  const target = payload.target as HTMLInputElement;
  emits('change', target.value);
};

return { __sfc: true,emits, onChange }
}

})